export const MAL = 'mal';
export const NP = 'np';
export const PBS = 'pbs';

export const NP_LABEL = 'Nettoyage patrimonial';
export const DF_LABEL = 'Dégraffitage';

export const MULTIPLE_AVAILABILITY = 'Mise à disposition multiple';

export const MAX_PAD_WIDTH = 992;
export const MAX_MOBILE_WIDTH = 576;

// Colors
export const PRIMARY = 'primary';

// Actions
export const DELETE = 'Supprimer';
export const CANCEL = 'Annuler';
export const VALIDATE = 'Valider';
